<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'app',
  }
</script>

<style lang="scss">
  // reset
  * {
    font: inherit;
    display: block;
    border: 0;
    padding: 0;
    margin: 0;
    color: inherit;
    background: transparent;
    text-decoration: none;
    box-sizing: border-box;
  }

  head, script {
    display: none;
  }

  html {
    font-size: 13px;
    font-family: "Libre Baskerville", "Helvetica Neue", Helvetica, Arial, sans-serif;
    // color: $base;
    background-color: #777;
    background-image: url('/bg.png');

    @include nav-shown {
      overflow-y: hidden;
    }
  }

  html, body, #app {
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    overflow-x: hidden;
  }

  #app {
    display: flex;
    flex-direction: column;
  }

  .fa-icon {
    display: inline-block;
    width: 1.5em;
    vertical-align: top;
  }
</style>
